import moment from 'moment'
// CalendarService(barrel) 순환 참조 방지를 위해 원본 모듈에서 직접 import
import { getCalendars } from './CalendarState'
import { meetingResponse } from './EventManager'
import EventInstance from './EventInstance'
import settings from 'popups/Settings'
import { VEvent, Attendee, VAlarm, DateWithTimeZone } from 'node-ical'

type RecurrenceEditMode = 'this' | 'all'
type MeetingResponseStatus = 'ACCEPTED' | 'TENTATIVE' | 'DECLINED' | 'NEEDS-ACTION'

interface Calendar {
  url: string
  owner: string
}

/**
 * Process meeting response for an event
 * @param event - The event instance to respond to
 * @param status - Response status (ACCEPTED, TENTATIVE, DECLINED, NEEDS-ACTION)
 * @param type - Response type ('this' for single instance, 'all' for series)
 * @param comment - Optional comment for the response
 * @param onSuccess - Callback function on successful response
 */
export const doMeetingResponse = (
  event: EventInstance,
  status: MeetingResponseStatus,
  type: RecurrenceEditMode,
  comment: string,
  onSuccess?: (success: boolean) => void,
): void => {
  const cal = getCalendars()?.find((c: any) => {
    return event.serverId.startsWith(c.url)
  }) as Calendar | undefined
  if (!cal) return
  const owner = cal.owner

  let targetEvent = event

  if (type === 'this') {
    // Exception 응답 처리 exception 생성 및 저장
    if (!targetEvent.exception) {
      // Exception이 없으면 생성
      const newException: Partial<VEvent> = {}
      newException.type = 'VEVENT'
      newException.transparency = targetEvent.event!.transparency
      newException.class = targetEvent.event!.class
      newException.summary = targetEvent.event!.summary
      newException.start = targetEvent.startDate as DateWithTimeZone
      if (newException.start) {
        ;(newException.start as any).tz = targetEvent.event!.start.tz
      }
      newException.datetype = targetEvent.event!.datetype
      newException.end = targetEvent.endDate as DateWithTimeZone
      if (newException.end) {
        ;(newException.end as any).tz = targetEvent.event!.end.tz
      }
      newException.location = targetEvent.event!.location
      newException.description = targetEvent.event!.description
      newException.uid = targetEvent.event!.uid
      newException.alarms =
        targetEvent.event!.alarms &&
        (Array.isArray(targetEvent.event!.alarms)
          ? targetEvent.event!.alarms
          : [targetEvent.event!.alarms]
        ).map((a: VAlarm) => {
          return { ...a }
        })
      const attendees = targetEvent.event!.attendee
      newException.attendee = attendees
        ? ((Array.isArray(attendees) ? attendees : [attendees]).map((a: Attendee) => {
            if (typeof a === 'string') return a
            const copied = { ...(a as any) }
            if (copied.params) {
              copied.params = { ...copied.params }
            }
            return copied
          }) as any)
        : undefined
      newException.organizer = targetEvent.event!.organizer
      newException.recurrenceid = newException.start

      if (!targetEvent.event!.recurrences) {
        targetEvent.event!.recurrences = {}
      }
      const recurrenceId = moment(newException.start).format('YYYY-MM-DD')
      targetEvent.event!.recurrences[recurrenceId] = newException as VEvent
      targetEvent = new EventInstance(
        targetEvent.serverId,
        targetEvent.etag,
        targetEvent.color,
        targetEvent.event,
        targetEvent.startDate,
        newException as VEvent,
      )
    }

    const exceptionAttendee = targetEvent.exception!.attendee
    if (!exceptionAttendee) {
      targetEvent.exception!.attendee = targetEvent.attendees.map((a: Attendee) => {
        if (typeof a === 'string') return a
        const copied = { ...(a as any) }
        if (copied.params) {
          copied.params = { ...copied.params }
        }
        return copied
      }) as any
    }

    const attendeeArray = Array.isArray(exceptionAttendee)
      ? exceptionAttendee
      : exceptionAttendee
        ? [exceptionAttendee]
        : []
    const myAttendee = attendeeArray.find((a: Attendee) => {
      const attendeeVal = typeof a === 'string' ? a : (a as any).val
      let email = attendeeVal.toLowerCase()
      if (email.startsWith('mailto:')) {
        email = email.substring(7)
      }
      return email === owner.toLowerCase()
    })
    if (myAttendee && typeof myAttendee !== 'string') {
      ;(myAttendee as any).params.PARTSTAT = status
      targetEvent.reload()
    }
  } else {
    const attendees = targetEvent.attendees

    const attendee = attendees.find((a: Attendee) => {
      const attendeeVal = typeof a === 'string' ? a : (a as any).val
      return attendeeVal === owner
    })
    if (attendee && typeof attendee !== 'string') {
      ;(attendee as any).params.PARTSTAT = status
      targetEvent.reload()
    } else {
      // 참석자에 내가 없는 경우 참석자 추가 / 지금은 응답을 하지 못하도록 UI에서 막아둬서 호출되지 않음.
      const name = settings.getValue('account').accountName as string
      const eventAttendee = targetEvent.event!.attendee
      const attendeeList = eventAttendee
        ? Array.isArray(eventAttendee)
          ? eventAttendee
          : [eventAttendee]
        : []
      attendeeList.push({
        val: owner,
        params: {
          RSVP: true,
          ROLE: 'REQ-PARTICIPANT',
          CN: name ? name : '',
          PARTSTAT: status,
        },
      } as any)
      targetEvent.event!.attendee = attendeeList as any
      targetEvent.reload()
    }
  }

  if (type === 'this') {
    if (status === 'ACCEPTED') {
      targetEvent.exception!.transparency = 'OPAQUE'
    } else {
      targetEvent.exception!.transparency = 'TRANSPARENT'
    }
  } else {
    if (status === 'ACCEPTED') {
      targetEvent.event!.transparency = 'OPAQUE'
    } else {
      targetEvent.event!.transparency = 'TRANSPARENT'
    }
  }

  meetingResponse(targetEvent, comment, (success: boolean) => {
    console.log('meeting response success')
    onSuccess?.(success)
  })
}
